__turbopack_context__.v({
  "cancel-button": "RelayNumberConfirmationModal-module-scss-module__L0MkaW__cancel-button",
  "confirm-button": "RelayNumberConfirmationModal-module-scss-module__L0MkaW__confirm-button",
  "dialog-content": "RelayNumberConfirmationModal-module-scss-module__L0MkaW__dialog-content",
  "dialog-wrapper": "RelayNumberConfirmationModal-module-scss-module__L0MkaW__dialog-wrapper",
  "underlay": "RelayNumberConfirmationModal-module-scss-module__L0MkaW__underlay",
});
